<div class="form-floating">
  <select class="form-select "
          id="Geschlecht"
          [(ngModel)]="Geschlecht" (ngModelChange)="onStatusChange($event)">
    <option *ngFor="let item of Data" [ngValue]="item.key" >
      {{ item.Bezeichnung }}
    </option>
  </select>
  <label for="Geschlecht">Geschlecht</label>
</div>
